import gaParams from '../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../utilities/analytics/tracking';
import {
  otpValidationPopupContent,
  customerTypeEnum,
  lobbyTabsEnum,
  searchParametersEnum,
  pages,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';

export function gaOnLoadTicket(
  businessOrPrivate,
  isFamilyProcess,
  startedFromPackage,
  comingFromPackageManager,
  isBusinessIndividual,
  params,
) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_IS_SHOWN.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_IS_SHOWN.eventType,
      params,
    );
  } else {
    if (!isFamilyProcess) {
      switch (businessOrPrivate) {
        case customerTypeEnum.PRIVATE:
          if (!startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step6_PackageSummaryPage',
              step: '6',
              action: 'PackageSummaryPage',
              process_type: 'private',
              funnel_name: '2 - SearchArea',
            });
          }

          break;
        case customerTypeEnum.BUSINESS:
          if (startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step1_PackageSummaryPage',
              step: '7',
              action: 'PackageSummaryPage',
              process_type: 'business',
              funnel_name: '3 - Packages - Business',
            });
          } else {
            gtag4({
              event: 'CellcomAbroad_Step7_PackageSummaryPage',
              step: '7',
              action: 'PackageSummaryPage',
              process_type: 'business',
              funnel_name: '2 - SearchArea - Business',
            });
          }

          break;
        default:
          break;
      }
    }

    if (isFamilyProcess) {
      if (comingFromPackageManager) {
        gaEvent(
          gaParams.ABROAD_FAMILY_DISPLAY_SUMMARY_DEAL_ON_TICKET.category,
          gaParams.ABROAD_FAMILY_DISPLAY_SUMMARY_DEAL_ON_TICKET.eventType,
          gaParams.ABROAD_FAMILY_DISPLAY_SUMMARY_DEAL_ON_TICKET.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_FAMILY_SHOW_SUMMARY_PAGE_INITIAL_TICKET_FLOW.category,
          gaParams.ABROAD_FAMILY_SHOW_SUMMARY_PAGE_INITIAL_TICKET_FLOW.eventType,
          gaParams.ABROAD_FAMILY_SHOW_SUMMARY_PAGE_INITIAL_TICKET_FLOW.eventParams,
        );
      }
    }
  }
}
export function gaChangeTripDate(businessOrPrivate, startedFromPackage, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_START_DATE_BUTTON_CLICK.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_START_DATE_BUTTON_CLICK.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_START_DATE_BUTTON_CLICK.eventParams,
    );
  } else {
    switch (businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE.category,
            gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_PRIVATE.eventParams,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_CHANGEDATESOPENTICKET_CLICK.category,
            gaParams.SEPARATED_CHANGEDATESOPENTICKET_CLICK.eventType,
            gaParams.SEPARATED_CHANGEDATESOPENTICKET_CLICK.eventParams,
          );
        } else {
          if (startedFromPackage) {
            gaEvent(
              gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE.eventType,
              gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS.category,
              gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS.eventType,
              gaParams.ABROAD_TICKET_CHANGE_START_DATE_BUTTON_CLICK_BUSINESS.eventParams,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaChangeAccountOnTicketPage() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_ACCOUNT_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_ACCOUNT_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHANGE_ACCOUNT_CLICK.eventParams,
  );
}
export function gaOnCheckTermCheckBox(businessOrPrivate, startedFromPackage, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHECKBOX_SELECTED.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHECKBOX_SELECTED.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_CHECKBOX_SELECTED.eventParams,
    );
  } else {
    switch (businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE.category,
            gaParams.ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_CHECKBOX_SELECTED_PRIVATE.eventParams,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        break;
      default:
        break;
    }
  }
}

export function gaClickOnAddPackageButton(businessOrPrivate, startedFromPackage, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_ADD_PACKAGE_BUTTON_CLICK.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_ADD_PACKAGE_BUTTON_CLICK.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_ADD_PACKAGE_BUTTON_CLICK.eventParams,
    );
  } else {
    switch (businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_ADD_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gtag4({
            event: 'CellcomAbroad_Step14_InstallPackageButton',
            button: 'להתקנת חבילה',
            step: '14',
            action: 'InstallPackageButton',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
          });
        }

        break;
      case customerTypeEnum.BUSINESS:
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_PACKAGEINSTALL_CLICK.category,
            gaParams.SEPARATED_PACKAGEINSTALL_CLICK.eventType,
            gaParams.SEPARATED_PACKAGEINSTALL_CLICK.eventParams,
          );
        } else {
          if (startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step2_PackageSummaryContinueButton',
              step: '2',
              button: 'להתקנת חבילה',
              action: 'PackageSummaryContinueButton',
              process_type: 'business',
              funnel_name: '3 - Packages - Business',
            });
          } else {
            gtag4({
              event: 'CellcomAbroad_Step8_PackageSummaryContinueButton',
              step: '8',
              button: 'להתקנת חבילה',
              action: 'PackageSummaryContinueButton',
              process_type: 'business',
              funnel_name: '2 - SearchArea - Business',
            });
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaDataIsBlockedOnLoad(businessOrPrivate, startedFromPackage, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED.eventParams,
    );
  } else {
    switch (businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE.category,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_PRIVATE.eventParams,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS.category,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS.eventType,
            gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUSINESS.eventParams,
          );
        }

        break;
      default:
        break;
    }
  }
}

export function gaUnblockDataUsage(businessOrPrivate, startedFromPackage) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE.eventType,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_CANCEL_BLOCKED_PRIVATE.eventParams,
        );
      }

      break;
    case customerTypeEnum.BUSINESS:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS_FROM_PACKAGE.eventType,
          `הסירו את חסימת הגלישה`,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS.eventType,
          `הסירו את חסימת הגלישה`,
        );
      }
      break;
    default:
      break;
  }
}
export function gaUnblockDataUsageBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION.eventType,
    `הסירו את חסימת הגלישה`,
  );
}

export function gaStayWithBlockedDataUsage(businessOrPrivate, startedFromPackage) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE.eventType,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_STAY_WITH_BLOCKED_PRIVATE.eventParams,
        );
      }

      break;
    case customerTypeEnum.BUSINESS:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS_FROM_PACKAGE.eventType,
          `תשאירו את החסימת גלישה`,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS.category,
          gaParams.ABROAD_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION_BUSINESS.eventType,
          `תשאירו את החסימת גלישה`,
        );
      }
      break;
    default:
      break;
  }
}

export function gaStayWithBlockedDataUsageBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION.eventType,
    `תשאירו את החסימת גלישה`,
  );
}

export function gaCloseBlockedDataUsagePopupBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_DATA_USAGE_IS_BLOCKED_BUTTON_ACTION.eventType,
    `אל תתקינו חבילה, תנו לי לחשוב`,
  );
}

export function gaCompletedSuccessfulPage(
  businessOrPrivate,
  businessIndividualLobby,
  isFamilyProcess,
  isSeparatedSale,
  startedFromPackage,
  unqualifiedSubs,
  comingFromPackageManager,
  addons,
) {
  if (businessIndividualLobby) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS.eventParams,
    );
  } else {
    if (!isFamilyProcess) {
      switch (businessOrPrivate) {
        case customerTypeEnum.PRIVATE:
          if (startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step15_InstallPackageSuccessPage',
              button: 'סיום',
              step: '15',
              action: 'InstallPackageSuccessPage',
              process_type: 'private',
              funnel_name: '2 - SearchArea',
            });
          } else {
            gtag4({
              event: 'CellcomAbroad_Step12_InstallPackageSuccessPage',
              button: 'סיום',
              step: '12',
              action: 'InstallPackageSuccessPage',
              process_type: 'private',
              funnel_name: '3 - Package',
            });
          }

          break;
        case customerTypeEnum.BUSINESS:
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_INSTALLEDSUCCESSFULLY_SHOW.category,
              gaParams.SEPARATED_INSTALLEDSUCCESSFULLY_SHOW.eventType,
              gaParams.SEPARATED_INSTALLEDSUCCESSFULLY_SHOW.eventParams,
            );
          } else {
            if (startedFromPackage) {
              gtag4({
                event: 'CellcomAbroad_Step3_SuccessPage',
                step: '3',
                action: 'SuccessPage',
                process_type: 'business',
                funnel_name: '3 - Packages - Business',
              });
            } else {
              gtag4({
                event: 'CellcomAbroad_Step9_SuccessPage',
                step: '9',
                action: 'SuccessPage',
                process_type: 'business',
                funnel_name: '2 - SearchArea - Business',
              });
            }
          }

          break;
        default:
          break;
      }
    } else {
      if (unqualifiedSubs < 5) {
        if (comingFromPackageManager) {
          gaEvent(
            gaParams.ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL.category,
            gaParams.ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL.eventType,
            gaParams.ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL.eventParams,
          );
        } else {
          gaParams.ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL_TICKET_FLOW.category,
            gaParams.ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL_TICKET_FLOW.eventType,
            gaParams.ABROAD_FAMILY_SUCCSESFULL_SCREEN_AFTER_INSTALL_TICKET_FLOW.eventParams;
        }
      } else {
        if (comingFromPackageManager) {
          gaEvent(
            gaParams.ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT.category,
            gaParams.ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT.eventType,
            gaParams.ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT_TICKET_FLOW.category,
            gaParams.ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT_TICKET_FLOW.eventType,
            gaParams.ABROAD_FAMILY_FAILED_INSTALL_REACH_LIMIT_TICKET_FLOW.eventParams,
          );
        }
      }
    }
  }
  if (addons) {
    gtag4({
      event: 'AbroadAddons_Step1_SuccessPage',
      step: '1',
      action: 'SuccessPage',
      funnel_name: '1 - AddonsPurchase ',
    });
    gtag4({
      event: 'AbroadAddons_Step1_AddonsDisplayPage',
      content: addons.map((x) => x.packageName)
        .join(','),
      step: '1',
      action: 'AddonsDisplayPage',
      funnel_name: '1 - AddonsPurchase ',
    });
  }
}

export function gaOrderTheSamePackageForDifferentAccount(businessOrPrivate, startedFromPackage, buttonName) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step16_DiscountedPackageForFamilyMemberButton',
          button: buttonName,
          step: '16',
          action: 'DiscountedPackageForFamilyMemberButton',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
        });
      } else {
        gaEvent();
      }

      break;
    case customerTypeEnum.BUSINESS:
      break;
    default:
      break;
  }
}
export function gaContinuePurchaseBusinessIndividual(buttonName) {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_PURCHASE_FOR_SOMEBODY_ELSE_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_PURCHASE_FOR_SOMEBODY_ELSE_CLICK.eventType,
    buttonName,
  );
}
export function gaReturnToLobbyFromTicket(businessOrPrivate, isFamilyProcess, isSeparatedSale, startedFromPackage) {
  if (!isFamilyProcess) {
    switch (businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        break;
      case customerTypeEnum.BUSINESS:
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_SUCCESSFINISHINSTALLED_CLICK.category,
            gaParams.SEPARATED_SUCCESSFINISHINSTALLED_CLICK.eventType,
            gaParams.SEPARATED_SUCCESSFINISHINSTALLED_CLICK.eventParams,
          );
        } else {
          if (startedFromPackage) {
            gaEvent(
              gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS_FROM_PACKAGE.eventType,
              gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS_FROM_PACKAGE.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS.category,
              gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS.eventType,
              gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_FINISH_BUTTON_BUSINESS.eventParams,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaGoToMyPackages(businessOrPrivate, startedFromPackage) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE.category,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE.eventType,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_PRIVATE.eventParams,
        );
      }
      break;
    case customerTypeEnum.BUSINESS:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS_FROM_PACKAGE.category,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS_FROM_PACKAGE.eventType,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS_FROM_PACKAGE.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS.category,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS.eventType,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_GO_TO_MY_ABROAD_DATA_CLICK_BUSINESS.eventParams,
        );
      }
      break;
    default:
      break;
  }
}

export function gaReportBannerClick(bannerUrl, businessOrPrivate, startedFromPackage) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_ON_BANNER_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_ON_BANNER_PRIVATE_FROM_PACKAGE.eventType,
          bannerUrl,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_ON_BANNER_PRIVATE.category,
          gaParams.ABROAD_COMPLETED_WITH_SUCCESS_CLICK_ON_BANNER_PRIVATE.eventType,
          bannerUrl,
        );
      }

      break;
    case customerTypeEnum.BUSINESS:
      break;
    default:
      break;
  }
}

export function gaLoadingErrorPageGeneralError(businessOrPrivate, startedFromPackage, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR.eventParams,
    );
  } else {
    if (businessOrPrivate == customerTypeEnum.PRIVATE) {
      if (startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step13_GeneralErrorPage',
          step: '17',
          action: 'GeneralErrorPage',
          process_type: 'private',
          funnel_name: '3 - Package',
          error: 'שגיאה כללית',
        });
      } else {
        gtag4({
          event: 'CellcomAbroad_Step17_GeneralErrorPage',
          step: '17',
          action: 'GeneralErrorPage',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
          error: 'שגיאה כללית',
        });
      }
    } else {
      if (startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step4_ErrorMessage',
          step: '4',
          action: 'ErrorMessage',
          process_type: 'business',
          error: 'שגיאה כללית',
          funnel_name: '3 - Packages - Business',
        });
      } else {
        gtag4({
          event: 'CellcomAbroad_Step10_ErrorMessage',
          step: '10',
          action: 'ErrorMessage',
          process_type: 'business',
          error: 'שגיאה כללית',
          funnel_name: '2 - SearchArea - Business',
        });
      }
    }
  }
}
export function gaGoToStartBusinessIndividual(errorCode) {
  switch (errorCode) {
    case '96':
    case 'ER006':
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK.eventType,
        'סיום',
      );
      break;
    case '39':
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK.eventType,
        'סיום',
      );
      break;
    default:
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR_BUTTON_CLICK.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR_BUTTON_CLICK.eventType,
        'סיום',
      );
      break;
  }
}
export function gaCallBackButtonClick(
  businessOrPrivate,
  errorCode,
  startedFromPackage,
  businessIndividualLobby,
  isSeparatedSale,
  isOverlappingPackage,
  overlappingText,
) {
  if (isOverlappingPackage) {
    gtag4({
      event: 'AbroadContinuationPackages_FreeCallButton',
      text: overlappingText,
      button: 'שיחת חינם',
      action: 'FreeCallButton',
    });
  } else {
    if (businessIndividualLobby) {
      switch (errorCode) {
        case '96':
        case 'ER006':
          gaEvent(
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK.category,
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK.eventType,
            `הקליקו לשיחה`,
          );
          break;
        case '39':
          gaEvent(
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK.category,
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK.eventType,
            `הקליקו לשיחה`,
          );

          break;
        default:
          gaEvent(
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR_BUTTON_CLICK.category,
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_GENERAL_ERROR_BUTTON_CLICK.eventType,
            `הקליקו לשיחה`,
          );
          break;
      }
    } else {
      switch (businessOrPrivate) {
        case customerTypeEnum.PRIVATE:
          if (errorCode == '96' || errorCode == 'ER006' || errorCode == '39') {
            if (startedFromPackage) {
              gaEvent(
                gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE.category,
                gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE.eventType,
                gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE.category,
                gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE.eventType,
                gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_PRIVATE.eventParams,
              );
            }
          } else {
            if (startedFromPackage) {
              gaEvent(
                gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE.category,
                gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE.eventType,
                gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE.category,
                gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE.eventType,
                gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_PRIVATE.eventParams,
              );
            }
          }

          break;
        case customerTypeEnum.BUSINESS:
          if (isSeparatedSale) {
            if (errorCode == '96' || errorCode == 'ER006') {
              gaEvent(
                gaParams.SEPARATED_FAILEDCALLERBUTTON_CLICK.category,
                gaParams.SEPARATED_FAILEDCALLERBUTTON_CLICK.eventType,
                gaParams.SEPARATED_FAILEDCALLERBUTTON_CLICK.eventParams,
              );
            } else {
              gaEvent(
                gaParams.SEPARATED_ERRORCALLERBUTTON_CLICK.category,
                gaParams.SEPARATED_ERRORCALLERBUTTON_CLICK.eventType,
                gaParams.SEPARATED_ERRORCALLERBUTTON_CLICK.eventParams,
              );
            }
          } else {
            if (errorCode == '96' || errorCode == 'ER006' || errorCode == '39') {
              if (startedFromPackage) {
                gaEvent(
                  gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE.category,
                  gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE.eventType,
                  gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE.eventParams,
                );
              } else {
                gaEvent(
                  gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS.category,
                  gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS.eventType,
                  gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_CALLBACK_CLICK_BUSINESS.eventParams,
                );
              }
            } else {
              if (startedFromPackage) {
                gaEvent(
                  gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE.category,
                  gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE.eventType,
                  gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS_FROM_PACKAGE.eventParams,
                );
              } else {
                gaEvent(
                  gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS.category,
                  gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS.eventType,
                  gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_CALLBACK_CLICK_BUSINESS.eventParams,
                );
              }
            }
          }
          break;
        default:
          break;
      }
    }
  }
}
export function gaGoToMyPackageErrorPage(
  businessOrPrivate,
  startedFromPackage,
  isSeparatedSale,
  isBusinessIndividual,
  errorCode,
  isOverlappingPackage,
  overlappingText,
) {
  if (isOverlappingPackage) {
    gtag4({
      event: 'AbroadContinuationPackages_HulSheliButton',
      text: overlappingText,
      action: 'HulSheliButton',
    });
  } else {
    if (isBusinessIndividual) {
      switch (errorCode) {
        case '96':
        case 'ER006':
          gaEvent(
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK.category,
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUTTON_CLICK.eventType,
            'לאזור חו"ל שלי',
          );
          break;
        case '39':
          gaEvent(
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK.category,
            gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE_BUTTON_CLICK.eventType,
            'לאזור חו"ל שלי',
          );
          break;
        default:
          break;
      }
    } else {
      switch (businessOrPrivate) {
        case customerTypeEnum.PRIVATE:
          if (startedFromPackage) {
            // TBD add GA
          } else {
            // TBD add GA
          }
          break;
        case customerTypeEnum.BUSINESS:
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FAILEDINSTALLHULSHELI_CLICK.category,
              gaParams.SEPARATED_FAILEDINSTALLHULSHELI_CLICK.eventType,
              gaParams.SEPARATED_FAILEDINSTALLHULSHELI_CLICK.eventParams,
            );
          } else {
            if (startedFromPackage) {
              gaEvent(
                gaParams.ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS_FROM_PACKAGE.category,
                gaParams.ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS_FROM_PACKAGE.eventType,
                gaParams.ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS_FROM_PACKAGE.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS.category,
                gaParams.ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS.eventType,
                gaParams.ABROAD_COMPLETED_WITH_FAIL_GO_TO_PACKAGE_BUSINESS.eventParams,
              );
            }
          }
          break;
        default:
          break;
      }
    }
  }
}

export function gaExtendedPackagesErrorPage(text) {
  gtag4({
    event: 'AbroadContinuationPackages_PurchasePackageButton',
    title: text,
    action: 'MainPage',
  });
}

export function gaGoToMarketPlaceFromErrorPage(text) {
  gtag4({
    event: 'AbroadContinuationPackages_PurchasePackageButton',
    title: text,
    button: 'לרכישת חבילות המשך',
    action: 'PurchasePackageButton',
  });
}

export function gaReturnToAbroadLobbyErrorPage(businessOrPrivate, completedWithCode, startedFromPackage, isSeparatedSale) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (completedWithCode == '96' || completedWithCode == 'ER006' || completedWithCode == '39') {
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE.category,
            gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE.eventType,
            gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_FINISH_BUTTON_CLICK_PRIVATE.eventParams,
          );
        }
      } else {
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE.category,
            gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE.eventType,
            gaParams.ABROAD_COMPLETED_WITH_GENERAL_ERROR_FINISH_BUTTON_CLICK_PRIVATE.eventParams,
          );
        }
      }

      break;
    case customerTypeEnum.BUSINESS:
      if (isSeparatedSale) {
        if (completedWithCode == '96' || completedWithCode == 'ER006') {
          gaEvent(
            gaParams.SEPARATED_FAILEDFINISHINSTALLED_CLICK.category,
            gaParams.SEPARATED_FAILEDFINISHINSTALLED_CLICK.eventType,
            gaParams.SEPARATED_FAILEDFINISHINSTALLED_CLICK.eventParams,
          );
        } else {
          gaEvent(
            gaParams.SEPARATED_ERRORFINISHINSTALLED_CLICK.category,
            gaParams.SEPARATED_ERRORFINISHINSTALLED_CLICK.eventType,
            gaParams.SEPARATED_ERRORFINISHINSTALLED_CLICK.eventParams,
          );
        }
      }
      break;
    default:
      break;
  }
}
export function gaLoadingErrorConflictPage(businessOrPrivate, startedFromPackage, businessIndividualLobby, errorCode) {
  if (businessIndividualLobby) {
    switch (errorCode) {
      case '96':
      case 'ER006':
        gaEvent(
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE.category,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE.eventType,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE.eventParams,
        );
        break;
      case '39':
        gaEvent(
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE.category,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE.eventType,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_ERROR_SAME_PACKAGE.eventParams,
        );
        break;
      default:
        break;
    }
  } else {
    if (businessOrPrivate == customerTypeEnum.PRIVATE) {
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE.category,
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE.eventType,
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_PRIVATE.eventParams,
        );
      }
    } else {
      if (startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step5_PackageExistingErrorMessage',
          step: '5',
          action: 'PackageExistingErrorMessage',
          process_type: 'business',
          error: 'כבר קיימת חבילה',
          funnel_name: '2 - SearchArea - Business',
        });
      } else {
        gaEvent(
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUSINESS.category,
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUSINESS.eventType,
          gaParams.ABROAD_COMPLETED_WITH_ERROR_CONFLICT_EXISTING_PACKAGE_BUSINESS.eventParams
        );
      }
    }
  }
}

export function gaErrorInstallPackageSeparated() {
  gaEvent(
    gaParams.SEPARATED_ERRORINSTALLPACKAGE_SHOW.category,
    gaParams.SEPARATED_ERRORINSTALLPACKAGE_SHOW.eventType,
    gaParams.SEPARATED_ERRORINSTALLPACKAGE_SHOW.eventParams,
  );
}

export function gaFailedInstallPackageSeparated() {
  gaEvent(
    gaParams.SEPARATED_FAILEDINSTALLPACKAGE_SHOW.category,
    gaParams.SEPARATED_FAILEDINSTALLPACKAGE_SHOW.eventType,
    gaParams.SEPARATED_FAILEDINSTALLPACKAGE_SHOW.eventParams,
  );
}

export function gaToSelfCareLobbyFromTicketBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_FINISH_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_FINISH_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_COMPLETED_WITH_SUCCESS_FINISH_BUTTON_CLICK.eventParams,
  );
}

export function gaTicketPhoneValueIsNotValid(businessOrPrivate) {
  if (businessOrPrivate == customerTypeEnum.PRIVATE) {
    gaEvent(
      gaParams.ABROAD_TICKET_PHONE_VALUE_IS_NOT_VALID_PRIVATE.category,
      gaParams.ABROAD_TICKET_PHONE_VALUE_IS_NOT_VALID_PRIVATE.eventType,
      gaParams.ABROAD_TICKET_PHONE_VALUE_IS_NOT_VALID_PRIVATE.eventParams,
    );
  }
}

export function gaTicketOtpStep(businessOrPrivate) {
  if (businessOrPrivate == customerTypeEnum.PRIVATE) {
    gaEvent(
      gaParams.ABROAD_TICKET_OTP_STEP_PRIVATE.category,
      gaParams.ABROAD_TICKET_OTP_STEP_PRIVATE.eventType,
      gaParams.ABROAD_TICKET_OTP_STEP_PRIVATE.eventParams,
    );
  }
}

export function gaClickToOrderAddon() {
  gtag4({
    event: 'AbroadAddons_Step1_AddonButton',
    step: '1',
    action: 'AddonButton',
    funnel_name: '1 - AddonsPurchase ',
  });
}

export function gaTicketPopupAddon() {
  gtag4({
    event: 'AbroadAddons_Step2_AddonPopupInfo',
    step: '2',
    action: 'AddonPopupInfo',
    funnel_name: '1 - AddonsPurchase ',
  });
}
export function gaOrderAddon() {
  gtag4({event: 'AbroadAddons_Step2_AddonPopupInfo', step: '2', action: 'AddonPopupInfo', funnel_name: '1 - AddonsPurchase '});
}
export function gaSuccessOrderAddon() {
  gtag4({
    event: 'AbroadAddons_Step3_AddonPurchaseSuccessPage',
    step: '3',
    action: 'AddonPurchaseSuccessPage',
    funnel_name: '1 - AddonsPurchase ',
  });
}
export function gaFailedOrderAddon(error) {
  gtag4({
    event: 'AbroadAddons_Step3_AddonPurchaseErrorMessage',
    error,
    step: '3',
    action: 'AddonPurchaseErrorMessage',
    funnel_name: '1 - AddonsPurchase ',
  });
}

export function gaExistingAddons(packageName) {
  gtag4({
    event: 'AbroadAddons_Step1_AddonsPageHulSheli',
    content: packageName,
    step: '1',
    action: 'AddonsPageHulSheli',
    funnel_name: '2 - AddonsInfo ',
  });
}

export function gaExistingAddonsDetails(packageName) {
  gtag4({
    event: 'AbroadAddons_Step1_AddonInfoButton',
    button: 'פרטים נוספים',
    content: packageName,
    step: '1',
    action: 'AddonInfoButton',
    funnel_name: '2 - AddonsInfo ',
  });
}
export function gaCancelAddonsStep1(packageName) {
  gtag4({
    event: 'AbroadAddons_Step1_CancelationButton',
    content: packageName,
    button: 'ביטול',
    step: '1',
    action: 'CancelationButton',
    funnel_name: '2 - AddonsInfo ',
  });
}
export function gaCancelAddonPopup(packageName) {
  gtag4({
    event: 'AbroadAddons_Step2_AddonCancelationPopup',
    content: packageName,
    step: '2',
    action: 'AddonCancelationPopup',
    funnel_name: '2 - AddonsInfo ',
  });
}
export function gaCancelAddonsStep2(packageName) {
  gtag4({
    event: 'AbroadAddons_Step2_AddonCancelationButtonPopup',
    content: packageName,
    button: 'ביטול חבילה',
    step: '2',
    action: 'AddonCancelationButtonPopup',
    funnel_name: '2 - AddonsInfo ',
  });
}
export function gaScreenIlPopupDetails() {
  gtag4({
    event: 'AbroadAddons_Step2_AddonPopupInfo',
    step: '2',
    action: 'AddonPopupInfo',
    funnel_name: '2 - AddonsInfo ',
  });
}
